import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function TermsOfUse() {
  useEffect(() => {
    document.title = 'JourneyBot Terms of Use';
  }, []);

  return (
    <Box sx={{ bgcolor: 'background.default', color: 'text.primary', textAlign: 'left', py: { xs: 4, md: 7 } }}>
      <Container maxWidth="md">
        <Stack spacing={4}>
          <Box>
            <Typography variant="h3" component="h1" sx={{ fontWeight: 900, mb: 1 }}>
              JourneyBot Terms of Use
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Last updated: July 11, 2026
            </Typography>
          </Box>

          <Box component="section">
            <Typography variant="h5" component="h2" sx={{ fontWeight: 800, mb: 1.5 }}>
              1. Use of JourneyBot
            </Typography>
            <Typography variant="body1" paragraph>
              JourneyBot is a planning workspace for creating, organising, saving, importing, and
              exporting journey information. You are responsible for the information you enter and
              for deciding whether JourneyBot is appropriate for your use.
            </Typography>
            <Typography variant="body1">
              You must not use JourneyBot unlawfully, interfere with the service, or attempt to
              access another user&apos;s account or data.
            </Typography>
          </Box>

          <Box component="section" id="early-access-and-beta-service">
            <Typography variant="h5" component="h2" sx={{ fontWeight: 800, mb: 1.5 }}>
              Early Access and Beta Service
            </Typography>
            <Typography variant="body1" paragraph>
              JourneyBot is under active development. Features may be incomplete, changed, suspended,
              or removed, and availability is not guaranteed.
            </Typography>
            <Typography variant="body1" paragraph>
              Errors, interruptions, and data loss may occur. You should retain independent backups
              of important information and should not rely on JourneyBot as the only record of
              critical decisions or documents.
            </Typography>
            <Typography variant="body1" paragraph>
              AI-generated or imported content may be incomplete or inaccurate. JourneyBot is not a
              replacement for professional financial, legal, medical, or other advice. Important
              information should be independently verified before you rely on it.
            </Typography>
            <Typography variant="body1" paragraph>
              Feedback you provide may be used to improve JourneyBot. Early Access may later become a
              paid service, but notice will be provided before charges apply.
            </Typography>
            <Typography variant="body1">
              Nothing in these terms excludes, restricts, or modifies any rights or remedies that
              cannot legally be excluded, restricted, or modified.
            </Typography>
          </Box>

          <Box component="section">
            <Typography variant="h5" component="h2" sx={{ fontWeight: 800, mb: 1.5 }}>
              3. Privacy
            </Typography>
            <Typography variant="body1">
              JourneyBot handles information according to the{' '}
              <Link href="/privacy">Privacy Policy</Link>.
            </Typography>
          </Box>

          <Box component="section">
            <Typography variant="h5" component="h2" sx={{ fontWeight: 800, mb: 1.5 }}>
              4. Contact
            </Typography>
            <Typography variant="body1">
              For support or legal questions, contact{' '}
              <Link href="mailto:info@thedrunkbanana.com">info@thedrunkbanana.com</Link>.
            </Typography>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
}
